"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const select_1 = __importDefault(require("../select/select"));
const themes_1 = __importDefault(require("../../styles/themes"));
const FieldErrorMessageComponent_1 = __importDefault(require("../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const utils_1 = require("../../utils/utils");
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const sectionHeader_1 = __importDefault(require("../headers/sectionHeader"));
const auditConstants_1 = require("./auditConstants");
const auditUtils_1 = require("./auditUtils");
const icon_1 = __importDefault(require("../icon/icon"));
const colors_1 = __importDefault(require("../../styles/colors"));
const messageModalConstant_1 = require("../messageModal/messageModalConstant");
const button_1 = __importDefault(require("../button/button"));
const eventConstants_1 = require("../../constants/eventConstants");
const modal_1 = __importDefault(require("../modal/modal"));
const AuditFormFields = ({ values, handleChange, fields }) => {
    const [modalVisible, setModalVisible] = react_1.useState(false);
    const [selectedKey, setSelectedKey] = react_1.useState('');
    const demographic = [];
    const main = [];
    const handleFatal = () => {
        auditUtils_1.handleFatalSelection(fields, handleChange, selectedKey);
        setModalVisible(false);
    };
    const generateFormFields = (key, choices) => {
        const isDesktop = useWebDesktopDesign_1.default();
        const currentValue = values[key];
        const title = utils_1.formatTitle(key);
        return (react_1.default.createElement(react_native_1.View, { key: key, style: styles_1.default.marginTen },
            react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.fontSizeText] }, title),
            choices ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(select_1.default, { value: currentValue, setValue: () => { }, choices: choices, style: styles_1.default.select, setValueFormik: (choice) => {
                        return auditUtils_1.handleAuditScoreSelection(key, choice, handleChange, setModalVisible, setSelectedKey);
                    } }),
                react_1.default.createElement(modal_1.default, { title: "Warning!", visible: modalVisible, hideModal: () => setModalVisible(false), theme: {
                        colors: {
                            backdrop: 'transparent',
                        },
                    } },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.alignCenterCenter },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                            react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faExclamationCircle, color: colors_1.default.YELLOW, size: 50 })),
                        react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.marginFive] }, messageModalConstant_1.WARNING_MESSAGE),
                        react_1.default.createElement(react_native_1.Text, { style: [styles_1.default.modalText, styles_1.default.marginFive] }, `A fatal selection has been made. Updating this field will cause all other fields to be updated with a value of 0. `),
                        react_1.default.createElement(react_native_1.View, { style: [
                                styles_1.default.flexDirectionRow,
                                styles_1.default.alignCenterCenter,
                                styles_1.default.marginTen,
                            ] },
                            react_1.default.createElement(button_1.default, { onPress: handleFatal, eventName: eventConstants_1.PROCEED_FATAL_SELECTION, text: "Yes" }),
                            react_1.default.createElement(button_1.default, { onPress: () => setModalVisible(false), eventName: eventConstants_1.CANCEL_FATAL_SELECTION, text: "No" })))))) : (react_1.default.createElement(react_native_paper_1.TextInput, { label: title, onChangeText: handleChange(key), numberOfLines: isDesktop ? 1 : 4, value: currentValue, style: [styles_1.default.textInput, styles_1.default.marginTen, { width: isDesktop ? 500 : 220 }], theme: themes_1.default.textInput })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.alignItemsCenter] },
                react_1.default.createElement(formik_1.ErrorMessage, { name: key, component: FieldErrorMessageComponent_1.default }))));
    };
    fields.forEach(([key, item]) => {
        const field = generateFormFields(key, item.choices);
        if (auditConstants_1.DEMOGRAPHIC_FIELDS_KEYS.includes(key)) {
            demographic.push(field);
        }
        else {
            main.push(field);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(sectionHeader_1.default, { section: `Demographic ` }),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap] }, demographic)),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(sectionHeader_1.default, { section: `Main ` }),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap] }, main))));
};
exports.default = AuditFormFields;
